// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RegisterSuccess_wrapper__1tNwi","logoContainer":"RegisterSuccess_logoContainer__3Bikt","mainContent":"RegisterSuccess_mainContent__2pbMd"};